import { render, staticRenderFns } from "./ProductFieldsPicker.vue?vue&type=template&id=2947a10f&scoped=true&"
import script from "./ProductFieldsPicker.vue?vue&type=script&lang=js&"
export * from "./ProductFieldsPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947a10f",
  null
  
)

export default component.exports